import * as React from 'react';
import { InputWrapperInput } from '../../../../../../internal/components/InputWrapperInput/InputWrapperInput';
import styles from './CharInput.module.css';
import { InputWrapper } from '../../../../../../internal/components/InputWrapper';
import { FocusObserver } from '../../../../../../internal/components/FocusObserver/FocusObserver';
import { jsx as _jsx } from "react/jsx-runtime";
export const CharInput = /*#__PURE__*/React.forwardRef(function CharInput(props, ref) {
  const {
    value = '',
    disabled,
    invalid,
    focused,
    focusSource,
    onClick,
    onFocus,
    onBlur,
    onChange,
    onKeyDown,
    onPaste
  } = props;
  const handleFocus = (focused, source) => {
    if (focused) {
      onFocus(source);
    } else {
      onBlur();
    }
  };
  return /*#__PURE__*/_jsx(InputWrapper, {
    focused: focused,
    focusSource: focusSource,
    disabled: disabled,
    invalid: invalid,
    size: "M",
    width: 44,
    onClick: onClick,
    onKeyDown: onKeyDown,
    children: /*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(InputWrapperInput, {
        ref: ref,
        type: "tel",
        value: value,
        autoComplete: "off",
        maxLength: 1,
        tabIndex: -1,
        disabled: disabled,
        className: styles['input'],
        "data-mark": "ConfirmationInput|CharInput",
        onChange: e => onChange(e.currentTarget.value),
        onPaste: onPaste
      })
    })
  });
});